<template>
    <a
        :href="vacancyInfo.detailPageUrl"
        class="vacancies-card"
    >
        <div class="vacancies-card__content">
            <div class="vacancies-card__header">
                <div class="vacancies-card__header-wrapper">
                    <img class="vacancies-card__header-icon" src="/images/career/pin.svg" alt="">
                    <span class="vacancies-card__header-title">{{ vacancyInfo.city.value }}</span>
                </div>
                <div v-if="vacancyInfo.specialization" class="vacancies-card__tags">
                    <tag
                        class="vacancies-card__tags-item"
                        theme="gray"
                    >
                        {{ vacancyInfo.specialization.value }}
                    </tag>
                </div>
            </div>
            <z-caption class="vacancies-card__title" tag="h3">
                {{ vacancyInfo.name }}
            </z-caption>
        </div>
    </a>
</template>

<script>
export default {
    name: 'vacancies-card',
    props: {
        vacancyInfo: {
            type: Object,
            default: () => {}
        }
    }
}
</script>

<style lang="scss" scoped>
.vacancies-card {
    width: 100%;
    background-color: $token-colors-white;
    margin-bottom: $token-spacers-s;
    padding-bottom: $token-spacers-xs;
    border-bottom: 1px solid $token-colors-tertiary-15;
    cursor: pointer;
    text-decoration: none;
    display: block;

    &__header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: $token-spacers-2-xs;

        &-wrapper {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        &-icon {
            margin-right: 8px;
            width: 21px;
            height: 21px;

            @include breakpoint(tablet) {
                width: 18px;
                height: 18px;
            }

            @include breakpoint(mobile) {
                width: $token-spacers-2-xs;
                height: $token-spacers-2-xs;
            }
        }

        &-title {
            color: $token-colors-black-40;
            font-weight: 500;
            font-size: 16px;
            line-height: 140%;
        }

        @include breakpoint(mobile) {
            align-items: flex-start;
            flex-direction: column;
        }
    }

    &:hover {
        .vacancies-card__title {
            color: $token-colors-link-hover !important;
        }
    }

    @include breakpoint(mobile) {
        margin-bottom: 19px;
        padding-bottom: $token-spacers-s;
    }

    &__title {
        font-weight: 500 !important;
        font-size: 22px !important;
        line-height: 1.4 !important;
        color: $token-colors-link-default !important;
        margin-bottom: 0 !important;

        @include breakpoint(mobile) {
            font-size: 20px;
        }

        &-tag {
            margin-left: 10px;
            background: #F7F7F9;
            border-radius: 2px;
            padding: 4px $token-spacers-3-xs;
            color: #5D636D;
            font-size: 14px;
            line-height: 120%;
            font-weight: 400;
        }
    }

    &__tags {
        display: flex;
        flex-wrap: wrap;

        &-item {
            margin-left: 16px;

            @include breakpoint(mobile) {
                margin-top: 16px;
                margin-left: 0;
            }
        }
    }
}
</style>
